import { Modal, ModalFuncProps, ModalProps } from "antd";
export { Modal } from "antd";
export type { ModalProps, ModalFuncProps };

export const CommonModal = ({width = 600, ...props }: ModalProps) => (
  <Modal
    width={width}
    {...props}
    okButtonProps={{ size: "small", ...props.okButtonProps }}
    cancelButtonProps={{ size: "small", ...props.cancelButtonProps }}
  />
);

const commonConfirmProps: ModalFuncProps = {
  okButtonProps: { size: "small" },
  cancelButtonProps: { size: "small" },
};

export const CModal = {
  confirm: (props: ModalFuncProps) => Modal.confirm({ ...commonConfirmProps, ...props }),
  success: (props: ModalFuncProps) => Modal.success({ ...commonConfirmProps, ...props }),
  error: (props: ModalFuncProps) => Modal.error({ ...commonConfirmProps, ...props }),
  info: (props: ModalFuncProps) => Modal.info({ ...commonConfirmProps, ...props }),
  warning: (props: ModalFuncProps) => Modal.warning({ ...commonConfirmProps, ...props }),
};
